<div (click)="toggleCriteriaPanel()"
  class="criteria-card"
  [class.hide-panel]="showCriteriaPanel">

  <div class="row mx-0">
    <div class="col-md-2 border-end">
      <div class="vertical-text">
        <p id="selected-criteria-para">Selected Criteria</p>
      </div>
      <div><span class="fa fa-caret-right"></span>
        <span class="fa fa-caret-left"></span>
      </div>
    </div>
    <div card-content-container
      class="col-md-9">
      <div *ngFor="let key of listItemKeys; index as j">
        <div *ngIf="listItems[key] && listItems[key].length>0"
          [ngClass]="{'border-bottom-separator mb-2 pb-1': j !== positionOfLastKeyHavingData }">
          <label class="mt-2 mb-0 pb-0 fw-bold">{{ key.split('_')[0] }}</label>
          <ng-container *ngIf="listItems[key]?.length > 0 && !formId">
            <ng-container *ngFor="let value of listItems[key]; index as i">
              <p class="mb-0">{{ value }}<span *ngIf="i<listItems[key].length-1">,</span></p>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="listItems[key]?.length > 0 && formId">
            <ng-container *ngFor="let value of listItems[key]; index as i">
              <p class="mb-0">{{ value }}<span *ngIf="i<listItems[key].length-1"></span></p>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="showbutton"
      class="button-row mar-left-10">
      <button (click)="saveFilter($event)"
        class="btn-block btn-primary btn classic py-2">Save as a Filter</button>
    </div>
  </div>
</div>